import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Layout/Navbar";
import Home from "./components/Home";
import Footer from "./components/Layout/Footer";
import React from "react";
import Solutions from "./components/Pages/Solutions/Solutions";
import Pricing from "./components/Pages/Pricing/Pricing";
import OurWork from "./components/Pages/OurWork/OurWork"
import GetStarted from "./components/Pages/GetStarted";
import Privacy from "./components/Pages/Privacy";
import Terms from "./components/Pages/Terms";
import Account from "./components/Pages/Account";
import CompleteRegistration from "./components/Pages/CompleteRegistration";
import PrivateRoute from "./components/Layout/Routes/PrivateRoute";
import DocsPage from "./components/Pages/DocsPage";
// import BarCaligo from "./components/Pages/OurWork/SItes/BarCaligo";

function App() {
    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/solutions" element={<Solutions />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/our-work" element={<OurWork />} />
                <Route path="/get-started" element={<GetStarted />} />
                <Route path="/register" element={<CompleteRegistration />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/docs" element={<DocsPage />} />
                {/*<Route path="work/bar-caligo" element={<BarCaligo />} />*/}
                <Route path="*" element={<Navigate to="/" />} />
                <Route element={<PrivateRoute />}>
                    <Route path="/account" element={<Account />} />
                </Route>
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
